import { render } from "./TourCard.vue?vue&type=template&id=5bc4344a&scoped=true"
import script from "./TourCard.vue?vue&type=script&lang=js"
export * from "./TourCard.vue?vue&type=script&lang=js"

import "./TourCard.vue?vue&type=style&index=0&id=5bc4344a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc4344a"]])

export default __exports__